"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex w-full justify-between items-center" };
const _hoisted_2 = { class: "text-xl" };
const _hoisted_3 = { class: "flex items-center w-4/12 justify-between" };
const _hoisted_4 = { class: "text-xl" };
const _hoisted_5 = { class: "flex flex-col justify-center items-center" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "quantity-$extra->id",
    class: "label mb-1"
}, "Quantity", -1);
const _hoisted_7 = ["max"];
const _hoisted_8 = {
    key: 0,
    class: "text-xs"
};
const vue_3 = require("vue");
const Basket_1 = require("../../stores/Basket");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingExtraItem',
    props: {
        extra: {
            type: Object,
            required: true,
        },
        listing: {
            type: Object,
            required: true,
        },
        price: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const store = (0, Basket_1.useBasketStore)();
        const quantity = (0, vue_3.ref)(0);
        (0, vue_3.watch)(quantity, (newQuantity) => {
            store.setExtra(props.extra.id, 'extra', newQuantity, props.listing.slug);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(__props.extra.title), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(__props.price), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        _hoisted_6,
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            id: "quantity-$extra->id",
                            type: "number",
                            class: "input text-center w-32 py-3",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((quantity).value = $event)),
                            min: "0",
                            max: __props.extra.pivot.max_per_order
                        }, null, 8, _hoisted_7), [
                            [vue_2.vModelText, quantity.value]
                        ]),
                        (__props.extra.pivot.max_per_order)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_8, "Max " + (0, vue_2.toDisplayString)(__props.extra.pivot.max_per_order) + " per order", 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ])
            ]));
        };
    }
});
